import script from "./KanbanBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./KanbanBoard.vue?vue&type=script&setup=true&lang=js"

import "./KanbanBoard.vue?vue&type=style&index=0&id=5046fe35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5046fe35"]])

export default __exports__